<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router';

// PROPS
interface Props {
    message?: string;
    to?: RouteLocationRaw;
    iconName: string;
    iconClass: string;
}

defineProps<Props>();
</script>

<template>
    <p v-if="message || $slots.default" class="flex items-center justify-start gap-2 text-xs lg:text-sm">
        <UIcon :name="iconName" class="text-primary shrink-0 text-base" :class="iconClass" />
        <NuxtLink v-if="!!to" :to="to" class="underline" target="_blank">
            <slot :message="message">
                <span class="text-dimmed">
                    {{ message }}
                </span>
            </slot>
        </NuxtLink>

        <template v-else>
            <slot :message="message">
                <span class="text-dimmed">
                    {{ message }}
                </span>
            </slot>
        </template>
    </p>
</template>
